import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import { ListResponse } from '../models/list-response.model';
import { CreateUserPayload, UpdateUserPayload, UserProfile, UserStats } from '../models/user.models';

@Injectable({ providedIn: 'root' })
export class AdminUsersService {
  private readonly http = inject(HttpClient);

  list(page = 0, size = 20, query = '', includeAnonymous = false): Observable<ListResponse<UserProfile>> {
    let params = new HttpParams()
      .set('page', `${page}`)
      .set('size', `${size}`)
      .set('includeAnonymous', `${includeAnonymous}`);
    const trimmedQuery = query.trim();
    if (trimmedQuery.length > 0) {
      params = params.set('q', trimmedQuery);
    }
    return this.http.get<ListResponse<UserProfile>>(`${API_BASE_URL}/users/admin/search`, { params });
  }

  getById(userId: number): Observable<UserProfile> {
    return this.http.get<UserProfile>(`${API_BASE_URL}/users/${userId}`);
  }

  create(payload: CreateUserPayload): Observable<string> {
    return this.http.post(`${API_BASE_URL}/users`, payload, { responseType: 'text' });
  }

  update(userId: number, payload: UpdateUserPayload): Observable<UserProfile> {
    return this.http.put<UserProfile>(`${API_BASE_URL}/users/${userId}`, payload);
  }

  delete(userId: number): Observable<void> {
    return this.http.delete<void>(`${API_BASE_URL}/users/${userId}`);
  }

  getMemberStats(memberId: number): Observable<UserStats> {
    return this.http.get<UserStats>(`${API_BASE_URL}/users/member/${memberId}/stats`);
  }
}
